export default __webpack_public_path__ + "emblem-navy.png";